import { ActionMenuOption, AllowedActionMenuElements } from 'ui/actionMenu/types';
import { useTranslation } from 'modules/domains/list';
import { CHANNEL_SUBSCRIBE_URL } from '../../../constants';

export const useSubscribeUsersToChannelLink = (): ActionMenuOption => {
  const { t } = useTranslation();
  return {
    as: AllowedActionMenuElements.Link,
    content: t('indexPage.pageActions.subscribeUsersToChannel'),
    href: CHANNEL_SUBSCRIBE_URL,
    id: 'channel-subscribe-link',
  };
};
